import { useState } from "react";
import { createPortal } from "react-dom";
import { MUTATIONS, useMutation } from "../../../../../../api";
import CopyToClipboardButton from "../../../../../../design-system/components/CopyToClipboardButton/CopyToClipboardButton.jsx";
import IconButton from "../../../../../../design-system/components/IconButton/IconButton.jsx";
import Dialog from "../../../../../../design-system/components/Dialog/Dialog.jsx";
import Button from "../../../../../../design-system/components/Button/Button.jsx";
import { Variants } from "../../../../../../design-system/components/Button/Variants.jsx";
import styles from "./ResetPasswordDialog.css.ts";

const FALLBACK_ERROR =
  "Der Link konnte nicht erstellt werden. Bitte versuche es erneut.";

function ResetPasswordDialog({ user }) {
  const [open, setOpen] = useState(false);

  const [resetLink, setResetLink] = useState(null);
  const [error, setError] = useState(null);
  const [doCreateResetPasswordLink] = useMutation(
    MUTATIONS.createResetPasswordLink,
  );

  async function handleClick() {
    setResetLink(null);
    setError(null);
    setOpen(true);
    try {
      const res = await doCreateResetPasswordLink({ userId: user.id });
      if (res?.url) {
        setResetLink(res.url);
      } else {
        setError(FALLBACK_ERROR);
      }
    } catch (e) {
      setError(e?.message || FALLBACK_ERROR);
    }
  }

  const buttons = [
    <Button
      key={0}
      onClick={() => {
        setOpen(false);
      }}
      type="button"
      variant={Variants.PRIMARY}
    >
      Schließen
    </Button>,
  ];

  return (
    <>
      <div className={styles.iconButton}>
        <IconButton
          name="resetpassword"
          onClick={handleClick}
          title="Passwort zurücksetzen"
        />
      </div>

      {createPortal(
        <Dialog
          open={open}
          setOpen={setOpen}
          title={`Passwort von "${user.name}" zurücksetzen`}
          buttons={buttons}
        >
          <div className={styles.dialogContainer}>
            {error ? (
              <p className={styles.error}>{error}</p>
            ) : (
              <>
                <p>
                  Kopiere den Link und schicke ihn an die entsprechende Person,
                  damit sie ein neues Passwort einstellen kann.
                </p>
                {resetLink ? (
                  <CopyToClipboardButton value={resetLink} />
                ) : (
                  <p>Link wird erstellt …</p>
                )}
              </>
            )}
          </div>
        </Dialog>,
        document.body,
      )}
    </>
  );
}

export default ResetPasswordDialog;
